import Vue from 'vue';

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
*/

import * as moment from 'moment'
import Uy from './mixins/utilities.js'
import store from './store'

import SvgVue from 'svg-vue'
import VCalendar from 'v-calendar'
import ReadMore from 'vue-read-more'
import { BootstrapVue, BIcon, BIconCircle, BIconCircleHalf, BIconCircleFill } from 'bootstrap-vue'

import Loading from './components/Loading.vue'

Vue.use(SvgVue)
Vue.use(VCalendar)
Vue.use(BootstrapVue)
Vue.use(ReadMore)

Vue.component('BIcon', BIcon)
Vue.component('BIconCircle', BIconCircle)
Vue.component('BIconCircleHalf', BIconCircleHalf)
Vue.component('BIconCircleFill', BIconCircleFill)

Vue.prototype.$_ = _
Vue.prototype.$http = axios;
Vue.prototype.$moment = moment;
Vue.prototype.$bus = new Vue();

// Vue.config.devtools = false

const  FormSearch = () => import(/* webpackChunkName: "form-search" */ './components/FormSearch.vue');
const  SearchResult = () => import(/* webpackChunkName: "search-result" */ './components/SearchResult.vue');
const  Structure = () => import(/* webpackChunkName: "structure" */ './components/Structure.vue');
const  LoadingQuote = () => import(/* webpackChunkName: "loading-quote" */ './components/quote/alert/Loading.vue');
const  Quote = () => import(/* webpackChunkName: "quote" */ './components/Quote.vue');


Vue.mixin(Uy)

const app = new Vue({
    el: '#app',    
    store,
    components: {
        Loading,
        LoadingQuote,
        FormSearch,
        SearchResult,
        Structure,
        Quote
    }
});


let formactive = false

window.startFxExt = function startActionExternal(vm) {
    $(".open-form-search").on( "click touchstart", function() {
        if (formactive != $(this).attr("href")) {
            $(".search-form").removeClass("invisible");
            $(".search-form .tab-content.hidden").addClass("active");
            formactive = $(this).attr("href");
            $(".search-nav-link").removeClass("active");
            $('.search-nav-link[href*="' + formactive + '"]').addClass(
                "active"
            );
            $(".search-form .tab-content .tab-pane").removeClass("show active");
            $(formactive).tab("show");
    
            if ($(".search-form .tab-content.hidden").hasClass("active")) {
                $("body").css({ "padding-top": $("header").height() });
                $("header").eq(0).css("box-shadow", "none");
            }
        }
    
        if ($(this).data("strcodes")) {
            var dates = null;
            let packs = null
    
            if ($(this).data("from") && $(this).data("to"))
                dates = {
                    checkin: $(this).data("from"),
                    checkout: $(this).data("to")
                };
    
            if ($(this).data("rangefrom"))
                dates = { rangefrom: $(this).data("rangefrom") };
            
            if ($(this).data("packs")) {
                packs = $(this).data("packs")
            }

            vm.$emit("ext_openForm", $(this).data("strcodes"), dates, packs);
        }
    })
}

window.startFxExt(app)




